import { TrashIcon, PencilIcon } from "@heroicons/react/24/outline";
import { IconButton, Modal } from "../../../../../../../components/ui";
import DeleteCondition from "./DeleteConditionBody";
import AddCondition from "./AddConditionBody";

const Actions = (props = {}) => {
  const { row, instance } = props;
  const { id: conditionId, articheckId } = row;

  const modalProps = {
    body: AddCondition,
    closeOnBackdrop: false,
    row,
    instance,
    hideCloseButton: false,
    scale: "lg",
  };

  const deleteModalProps = {
    title: "ARE YOU SURE?",
    scale: "sm",
    description: `Would you like to delete this condition?`,
    closeOnBackdrop: true,
    body: DeleteCondition,
    id: conditionId,
  };

  if (articheckId) return null;

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <Modal {...modalProps}>
          <IconButton variant="clean" title="Edit">
            <PencilIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
        <Modal {...deleteModalProps}>
          <IconButton variant="clean" title="Delete">
            <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
